import { alpha, Box, Chip, SxProps, Tooltip } from '@mui/material';
import React from 'react';
import { CHIP_VARIANTS, SIZES } from '../../common/constants/constants';
import { useStyling } from '../../common/Theme';

type ProductionStatusChipsProps = {
    productionStatus?: string;
    projectStatus?: string;
    sx?: SxProps;
};

const styles = {
    px: 0.5,
    py: '2px',
    maxWidth: 140,
    '& .MuiChip-label': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block'
    }
};

export const ProductionStatusChips = ({ productionStatus, projectStatus, sx }: ProductionStatusChipsProps) => {
    const { theme } = useStyling();

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                alignItems: 'center',
                ...sx
            }}
        >
            {productionStatus && (
                <Tooltip title={productionStatus}>
                    <Chip
                        label={productionStatus}
                        variant={CHIP_VARIANTS.outlined}
                        size={SIZES.small}
                        sx={{
                            ...styles
                        }}
                    />
                </Tooltip>
            )}
            {projectStatus && (
                <Tooltip title={projectStatus}>
                    <Chip
                        label={projectStatus}
                        variant={CHIP_VARIANTS.filled}
                        size={SIZES.small}
                        sx={{
                            border: `3px solid ${alpha(theme.palette.action.disabled, 0.38)}`,
                            textTransform: 'uppercase',
                            ...styles
                        }}
                    />
                </Tooltip>
            )}
        </Box>
    );
};
